import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	headerTitle: {
		fontWeight: "bolder",
		color: colors.gray[0],
		textTransform: "uppercase"
	},
	header: {
		background: colors.green[400]
	}
})

export default useStyles
